<template lang="html">
  <div class="container cursorBox" @mousemove="onMouseMove" @mouseleave="onMouseLeaveScreen">
    <div class="follower"></div>
    <slot></slot>
  </div>
</template>

<script>
import {
  TweenMax,
  TimelineMax,
  Power0
} from 'gsap'
export default {
  name: 'Mouse',
  mounted() {
    TweenMax.set('.follower', {
      xPercent: -50,
      yPercent: -50
    });
    document.querySelector('.container').style.height = window.innerHeight
  },
  methods: {
    onMouseMove(e) {
      const cursorBox = e.target.closest('.cursorBox');
      const follower = cursorBox.querySelector('.follower');
      let target = e.target;
      var scrollTop = (window.pageYOffset !== undefined) ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;
      follower.style.opacity = 1;
      follower.style.borderColor = '#FFFFFF';
      follower.style.borderRadius = '50%';
      if (target.closest('.cross')) {
        follower.style.opacity = 0;
        return;
      }
      if (target.closest('.locations aside')) {
        follower.style.opacity = 0;
        return;
      }
      if (/hover/.test(target.classList) || target.closest('.hover')) {
        target = target.closest('.hover') || target;
        const targetRect = target.getBoundingClientRect();
        follower.style.height = `${targetRect.width + 40}px`;
        follower.style.width = `${targetRect.width + 40}px`;
        TweenMax.to(follower, 0.8, {
          x: targetRect.left + targetRect.width/2,
          y: targetRect.top + scrollTop + targetRect.height/2,
          ease: Power4.easeOut
        });
        return;
      }
      if (/hover/.test(target.classList) || target.closest('.filter')) {
        target = target.closest('.hover') || target;
        const targetRect = target.getBoundingClientRect();
        follower.style.height = `${targetRect.height + 0}px`;
        follower.style.width = `${targetRect.width + 0}px`;
        follower.style.borderColor = '#f33535';
        follower.style.borderRadius = '20px';
        TweenMax.to(follower, 0.8, {
          x: targetRect.left + targetRect.width/2,
          y: targetRect.top + scrollTop + targetRect.height/2,
          ease: Power4.easeOut
        });
        return;
      }
      follower.style.height = '40px';
      follower.style.width = '40px';
      TweenMax.to(follower, 0.8, {
        x: e.clientX + 1,
        y: scrollTop + e.clientY + 1,
        ease: Power4.easeOut
      });
    },
    onMouseLeaveScreen(e) {
      this.onMouseMove(e);

      const target = e.target;
      const follower = target.querySelector('.follower');
      follower.style.opacity = 0;
      // const rect = target.getBoundingClientRect();
      // const center = {
      //   w: Math.round(rect.width * 0.5),
      //   h: Math.round(rect.height * 0.5)
      // };
      // TweenMax.to(follower, 1, {
      //   x: center.w,
      //   y: center.h,
      //   ease: Back.easeInOut
      // })
    },
  }
}
</script>

<style lang="scss">
@import "../styles/config.scss";
  .container {
    width: 100%;
    height: auto;
    min-height: 100vh;
  }
  .follower {
    border-radius: 50%;
    display: flex;
    overflow: hidden;
    border: 2px solid var(--Neu01);
    position: absolute;
    left: 0;
    top: 0;
    pointer-events: none;
    transition: width .2s ease-in, height .2s ease-in, opacity .5s ease-in;
    z-index: 100;
    /* Very important to prevent the follower from messing up with the mouse move */
    @include mq(0, 1024px) {
      display: none;
    }
  }
  .follower>* {
    margin: auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/Mouse.vue